<mat-toolbar>
  <span class="pointer">Simulation génériqueur</span>
  <span class="spacer"></span>
  <app-filiale-selector></app-filiale-selector>
  <app-months-selector
    [availableMonths]="availableMonths"
    (onMonthsSelectionChange)="onMonthSelectionChange($event)"
    [selectedMonthsInput]="selectedMonths$.value ?? []"
  ></app-months-selector>
  <app-years-selector
    [availableYears]="availableYears"
    [selectedYearInput]="selectedYear$.value"
    (onYearSelectionChange)="onYearSelectionChange($event)"
  >
  </app-years-selector>
  <app-officine-selector type="Remise_generique"></app-officine-selector>
</mat-toolbar>

<div class="main">
  @if ((genericManufacturer$ | async)?.length === 0) {
    @if (activiteAdherent == 'gpo') {
      <div class="no-data">
        <span
          >Merci de contrôler que vous avez bien signé votre accord d'extraction de données. Cet
          accord est téléchargeable dans le module "Mes Autorisations".</span
        >
        <span
          >Merci de vérifier que les paramétrages de DIGIPHARMACIE sont corrects. Vous pouvez vous
          rapprocher de votre responsable de groupement si vous avez des questions.</span
        >
      </div>
    } @else {
      <div class="no-data">
        <span>Aucune remise générique trouvée</span>
      </div>
    }
  } @else {
    <mat-tab-group class="fixed-width-tabs" [animationDuration]="'150ms'">
      <mat-tab
        *ngFor="let manufacturer of genericManufacturer$ | async; trackBy: trackingKey"
        [label]="manufacturer.supplierName"
      >
        <app-manufacturer-table
          [genericManufacturer]="manufacturer"
          [selectedMonths]="selectedMonths$.value"
        ></app-manufacturer-table>
      </mat-tab>
    </mat-tab-group>
  }
</div>
